import { logAPI } from "../andyliticsApi";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
// this needs to be loaded dynamically (since it will change after startup)
//const hpServicesUrl = typeof window !== 'undefined' ? (window.serverData.data.hpServicesSpecificUrl ? window.serverData.data.hpServicesSpecificUrl : window.serverData.data.hpServicesUrl) : ''; // window is undefined during pre-render
import * as tools from "../../helpers/Tools";

export const getOtherCoverage = (token, memId) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), 'member/otherinsurance'));
    const params = {
        method: 'post',
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            MemberId: memId
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.OtherCoverage.GetOtherInsurance", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.OtherCoverage.GetOtherInsurance.Failure", start, url, err); return Promise.reject(err);
    });
};

export const updateOtherCoverage = (token, memId, subName, subBirthDate, subGender, rltpToSub, policyType, mbi, coverageType,
    planName, altPolicyNum, groupName, groupNumber, priority, isCourtOrdered, isRetiree, companyName, address, address2, city, state, zip, area, phoneNumber, extension, startDate, policyId) => {
    const url = encodeURI(tools.buildUrl(tools.hpAPIBaseURL(), 'member/updateotherinsurance'));
    const params = {
        method: 'post',
        headers: {
            "Authorization": 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            MemberId: memId,
            SubscriberName: subName,
            SubscriberBirthDate: subBirthDate,
            SubscriberGenderCode: subGender,
            RelationToSubscriber: rltpToSub,
            PolicyType: policyType,
            MBI: mbi,
            CoverageType: coverageType,
            BenefitPlanName: planName,
            AlternatePolicyNumber: altPolicyNum,
            GroupName: groupName,
            GroupNumber: groupNumber,
            Priority: priority,
            IsCourtOrdered: isCourtOrdered,
            IsRetiree: isRetiree,
            CompanyName: companyName,
            CompanyAddress: address && city && state && zip ? {
                Type: "Mailing",
                AddressLine1: address,
                AddressLine2: address2,
                City: city,
                State: state,
                ZipCode: zip,
                Telephones: phoneNumber && area ? [{
                    PhoneType: "Home",
                    AreaCode: area,
                    Number: phoneNumber,
                    Extension: extension
                }] : []
            } : null,
            StartDate: startDate,
            PolicySystemId: policyId ? policyId : 0//for updates
        })
    };
    var start = new Date();
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.OtherCoverage.UpdateOtherInsurance", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.OtherCoverage.UpdateOtherInsurance.Failure", start, url, err); return Promise.reject(err);
    });
};